module.exports = __webpack_public_path__ + "img/volcano.cbc77ec9.jpg";